import fb from 'images/social/facebook.svg';
import ig from 'images/social/instagram.svg';
import yt from 'images/social/youtube.svg';
import React, { PureComponent } from 'react';
import { Col, Container, Row } from 'react-grid-system';
// import PropTypes from 'prop-types';
import styles from './Footer.module.css';

class Footer extends PureComponent {
	render() {
		// const {} = this.props;
		//const {} = this.state;
		return (

				<Container fluid className={styles.Container}>
					<Row>
						<Col offset={{ md: 1 }}  md={10}>
							<div className={styles.Footer}>
								<ul className={styles.Social}>
									<li><img src={fb} alt=""/></li>
									<li><a href="https://www.instagram.com/kelpie.groenendael/"><img src={ig} alt=""/></a></li>
									<li><img src={yt} alt=""/></li>
								</ul>
								<div className={styles.Line}/>
							</div>
						</Col>
					</Row>
				</Container>
		);
	}
}

Footer.propTypes = {};

Footer.defaultProps = {};

export default Footer;